<template>
	<div class="price-table--feature-content-price">
		<div class="price-table--feature-content-price-inner">
			<div class="price-table--feature-content-price-title">Gratis</div>
			<div class="price-table--feature-content-price-info">Einfach testen!<br/>&nbsp;</div>
		</div>
		<div v-if="authLoaded && !isLoggedIn" class="price-table--feature-content-price-buy">
			<Button
				text="Los geht's"
				:href="buyButtonLink"
			/>
		</div>
		<div class="price-table--feature-content-price-free-info">
			Du bezahlst erst bei der ersten Kontaktierung!
		</div>
	</div>
</template>
<script>
import Button from "@/vue/common/Button.vue";
import {mapGetters, mapState} from "vuex";

export default {
	components: {Button},

	computed: {
		...mapState('auth', {
			'authLoaded': 'loaded',
			'customer': 'customer'
		}),
		...mapGetters('auth', ['isLoggedIn']),
		buyButtonLink ()
		{
			return this.isLoggedIn
				? '/kundenbereich/verrechnung?openPurchaseSubscriptionPopUp=1'
				: '/kunde/eintragung';
		},
	}
}
</script>
